<template>
  <div>
    <div class="pb-1">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="d-flex align-items-center">
          <h6 class="m-0">{{ $l('form_header_bank') || '客户银行账号' }}</h6>
          <el-divider direction="vertical" />
          <b-button
            size="sm"
            variant="outline-success"
            @click="addBank"
            :disabled="enableEdit"
          >
            {{ $l('btn_addBank') || '新增银行账号' }}
          </b-button>
        </div>
        <!-- <div>
          <vxe-button
            size="mini"
            circle
            @click="getBankData()"
            :disabled="enableEdit"
          >
            <i class="vxe-button--icon vxe-icon--refresh" />
          </vxe-button>
        </div> -->
      </div>

      <div class="cust-bank-list">
        <el-form
          v-for="(form, index) in newBankList"
          :key="index"
          ref="bankForm"
          :model="form"
          :rules="bankRules"
          size="mini"
          label-position="top"
          :disabled="!form.enableEdit"
        >
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_bankName') || '开户银行'"
                prop="bankName"
              >
                <el-input
                  v-model="form.bankName"
                  :placeholder="
                    $l('form_placeholder_bankName') || '请输入开户银行'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_bankAccountType') || '账户性质'"
                prop="bankAccountType"
              >
                <el-select
                  v-model="form.bankAccountType"
                  :placeholder="
                    $l('form_placeholder_bankAccountType') || '请选择账户性质'
                  "
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option
                    value="0"
                    :label="$l('form_label_bankAccountType_0') || '公司'"
                  />
                  <el-option
                    value="1"
                    :label="$l('form_label_bankAccountType_1') || '个人'"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_bankAccountKind') || '账号类别'"
                prop="bankAccountKind"
              >
                <dict-select
                  v-model="form.bankAccountKind"
                  :selectedLabel.sync="form.v_bankAccountKind"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'bankAccountKind' }"
                  :placeholder="
                    $l('form_placeholder_bankAccountKind') || '请选择账号类别'
                  "
                  size="mini"
                  clearable
                  filterable
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <template #label>
                  <div style="width: 100px"><br /></div>
                </template>
                <div class="text-right" v-if="!enableEdit && !form.enableEdit">
                  <el-tooltip
                    effect="dark"
                    :content="$l('INDEX.btn_tips_del') || '删除'"
                    placement="top"
                  >
                    <i
                      class="el-icon-delete text-danger tool-btn"
                      @click="deleteBank(index)"
                    />
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    :content="$l('INDEX.btn_tips_edit') || '编辑'"
                    placement="top"
                  >
                    <i class="el-icon-edit tool-btn" @click="editBank(form)" />
                  </el-tooltip>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_bankAccountName') || '账户名称'"
                prop="bankAccountName"
              >
                <el-input
                  v-model="form.bankAccountName"
                  :placeholder="
                    $l('form_placeholder_bankAccountName') || '请输入账户名称'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_bankAccountNo') || '银行账号'"
                prop="bankAccountNo"
              >
                <el-input
                  v-model="form.bankAccountNo"
                  :placeholder="
                    $l('form_placeholder_bankAccountNo') || '请输入银行账号'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div v-if="form.enableEdit" class="my-2 d-flex justify-content-end">
            <el-button size="small" @click="cancelEditBank(index)">
              {{ $l('INDEX.btn_cancel') || '取消' }}
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click="saveBank(form, index)"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </el-form>
        <EmptyContent v-if="!newBankList || !newBankList.length" />
      </div>
    </div>

    <el-form ref="formChange" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="mt-3 mb-1">
            <h6>
              <span class="text-danger">*</span>
              <span style="color: #101010">
                {{
                  $l('form_label_reason_change_explanation') || '变更原因说明'
                }}
              </span>
            </h6>
            <p
              style="font-size: 14px; color: #6c6c6c"
              class="m-0 text-truncate"
            >
              {{
                $l('form_ple_fill_in_explanation_for_change') ||
                '请填写本次变更信息的情况说明'
              }}
            </p>
          </div>
          <el-form-item prop="remark">
            <div>
              <el-input
                v-model="formData.remark"
                type="textarea"
                :rows="6"
                :maxlength="500"
                show-word-limit
                clearable
                @change="valueChange"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('dialog_want_to_submit_changes') || '是否要提交变更' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('btn_not_submit_changes') || '不提交变更' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('btn_submit_changes') || '提交变更' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initBank = { enableEdit: true }
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import EmptyContent from '../empty-content'
import { cloneDeep } from 'lodash'
export default {
  mixins: [EditLoading],
  components: { EmptyContent },
  props: {
    custCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      valueChangeFlag: false,
      formData: {},
      oldForm: {},
      newBankList: [],
      oldBankList: [],
      currBank: {},
      bankRules: {
        bankName: [
          {
            required: true,
            message: this.$l('form_placeholder_bankName') || '请输入开户银行',
            trigger: 'blur',
          },
        ],
        bankAccountType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountType') || '请选择账户性质',
            trigger: 'change',
          },
        ],
        bankAccountKind: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountKind') || '请选择账号类别',
            trigger: 'change',
          },
        ],
        bankAccountName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountName') || '请输入账户名称',
            trigger: 'blur',
          },
        ],
        bankAccountNo: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountNo') || '请输入银行账号',
            trigger: 'blur',
          },
        ],
      },
      rules: {
        remark: [
          {
            required: true,
            message: this.$l('form_placeholder_reason') || '请输入变更原因说明',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    enableEdit() {
      return this.newBankList.some((item) => !!item.enableEdit)
    },
  },
  mounted() {
    this.getData()
    this.getBankData()
  },
  methods: {
    valueChange() {
      this.valueChangeFlag = true
    },
    async getData() {
      if (!this.custCode) return
      this.loading = true
      const res = await this.$api
        .masterCustomerV2DetailApi({ custCode: this.custCode })
        .catch(() => {})
      this.loading = false
      const data = res.body || {}
      this.formData = { ...data }
      for (const key in this.formData) {
        const newKey = key + 'Old'
        this.oldForm[newKey] = this.formData[key]
      }
    },

    async getBankData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerBankListApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      const data = res.body?.data || []
      this.newBankList = data.map((item) => ({ ...item, enableEdit: false }))
      this.oldBankList = cloneDeep(this.newBankList)
    },

    deleteBank(index) {
      this.newBankList.splice(index, 1)
      this.valueChangeFlag = true
    },

    addBank() {
      this.newBankList.push({ ...initBank })
      this.currBank = null
      this.valueChangeFlag = true
    },

    editBank(bank) {
      if (this.enableEdit) return
      this.currBank = JSON.parse(JSON.stringify(bank))
      bank.enableEdit = true
      this.valueChangeFlag = true
    },
    async saveBank(bank, index) {
      if (!(await validate.formValidate([this.$refs['bankForm'][index]]))) {
        return
      }
      bank.enableEdit = false
      this.valueChangeFlag = true
    },
    cancelEditBank(index) {
      if (!this.currBank) {
        this.newBankList.splice(index, 1)
      } else {
        this.$set(this.newBankList, index, { ...this.currBank })
      }
    },

    async save() {
      if (!this.newBankList || !this.newBankList.length) {
        this.$message.warning(
          this.$l('tip_bank_account_cannot_be_empty') || '银行账号不能为空！'
        )
        return (this.backDialogVisible = false)
      }
      const enable = this.newBankList.find((item) => item.enableEdit === true)
      if (enable) {
        this.$message.warning(
          this.$l('tip_save_resubmit') || '请保存银行账号后重新提交变更！'
        )
        return (this.backDialogVisible = false)
      }

      this.newBankList.forEach((item) => {
        item.v_bankAccountType =
          item.bankAccountType == '0'
            ? this.$l('form_label_bankAccountType_0') || '公司'
            : this.$l('form_label_bankAccountType_1') || '个人'
      })

      const result = await validate.formValidate([this.$refs.formChange])
      const bankResult = await validate.formValidate(this.$refs.bankForm)
      if (!result || !bankResult) return (this.backDialogVisible = false)
      let param = {}
      for (const key in this.formData) {
        if (key == 'remark') continue
        const newKey = key + 'Old'
        if (this.oldForm[newKey] != this.formData[key]) {
          param[key] = this.formData[key]
        }
      }
      if (
        Object.keys(param).length === 0 &&
        JSON.stringify(this.newBankList) === JSON.stringify(this.oldBankList)
      ) {
        this.$message.warning(
          this.$l('tip_information_not_change') ||
            '信息未变更，请修改后重新提交变更！'
        )
        return (this.backDialogVisible = false)
      }
      param.newBankList = this.newBankList
      param.oldBankList = this.oldBankList
      param.remark = this.formData.remark

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerBankChangeApi({
          updateContent: JSON.stringify(param),
          custCode: this.formData.custCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_submission_failed') || '提交失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
      return true
    },

    cancel() {
      if (!this.valueChangeFlag) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.valueChangeFlag = false
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card {
    border: none;
  }
  .el-card__body {
    padding: 16px;
  }
  .el-divider--horizontal {
    margin: 12px 0;
  }

  .el-input .el-input__inner[flag='flag'] {
    background-color: #f9f9f9;
    border: none !important;
  }
}
.head_text {
  color: #101010;
  font-size: 16px;
  font-weight: 600;
}

::v-deep {
  .cust-takeOrder-list,
  .cust-bank-list {
    .el-form {
      background-color: #f4f6f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
    .no-data {
      color: #606266;
      font-size: 13px;
    }
  }
}
</style>
